<template>
  <div id="entire_app__container">
    <div v-if="$store.state.SidebarToggle.loadingPageData" :class="{'--booking_in_progress': $store.state.SidebarToggle.loadingPageData}" class="ticket_booking_order">
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../../assets/logo.png" alt="">
          <img class="loader" src="../../assets/loading.gif" alt="">
        </div>
      </div>
    </div> 
    <div
      class="entire_app__sidebar_container"
      :class="{
        '--sidebar_toggled': $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <AdminSidebar />
    </div>
    <div
      class="entire_app_mobile_sidebar_container"
      v-if="$store.state.Customizations.mobile_siderbar_toggled"
    >
      <admin-mobile-sidebar />
    </div>

    <div class="__mobile_navigation">
      <div class="logo_container">
        <div class="menu_toggle">
          <svg
            id="menu"
            @click="$store.commit('Customizations/togglemobilesidebar')"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 28 28"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H28V28H0Z"
              fill="none"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z"
              transform="translate(0)"
              fill="#1d2329"
            />
          </svg>
        </div>
        <div class="logo">
          <img src="../../assets/logo.png" alt="logo" />
        </div>
        <div class="settings">
          <router-link to="/admin/profile"
            ><svg
              @click="
                $store.commit('Customizations/togglemobilesidebartofalse')
              "
              id="settings"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 28"
            >
              <path
                id="Path_3"
                data-name="Path 3"
                d="M0,0H28V28H0Z"
                fill="none"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z"
                transform="translate(0 0)"
                fill="#1d2329"
              /></svg
          ></router-link>
        </div>
      </div>
    </div>
    <div
      class="entire_app__page_content"
      :class="{
        '--sidebar_toggled_expd_body':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <div class="page">
        <h5>
          <svg
            id="pulse-fill"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Path_31"
              data-name="Path 31"
              d="M0,0H24V24H0Z"
              fill="none"
            />
            <path
              id="Path_32"
              data-name="Path 32"
              d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
              fill="#1d2329"
            />
          </svg>
          Buses
        </h5>
      </div>
      <Toast position="bottom-right" group="br" />
      <div class="tableContainer mx-auto">
        <div class="d-flex mb-2">
          <h6>All Company Buses</h6>
          <div class="add-btn ml-auto">
            <button
              class="btn show-modal"
              data-toggle="modal"
              data-target="#myModal"
            >
              Add New Bus
            </button>
          </div>
        </div>
        <div class="adding-drivers" v-if="BusesNoDrivers.length != 0">
          <h6>Buses with no drivers</h6>
          <div
            class="no-drivers-buses justify-content-center d-flex flex-wrap py-2 my-2"
          >
            <div
              class="bus-card my-2 col-12 col-md-4 col-lg-3 mx-2"
              v-for="bus in BusesNoDrivers"
              :key="bus.id"
            >
              <div class="plate d-flex">
                <svg
                  class="mx-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M17 20H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1zM5 5v9h14V5H5zm0 11v2h4v-2H5zm10 0v2h4v-2h-4z"
                    fill="rgba(52,72,94,1)"
                  />
                </svg>
                <h6>{{ bus.busplatenumber }}</h6>
              </div>
              <div class="d-flex justify-content-center p-2 my-2">
                <button
                  data-toggle="modal"
                  @click="returnActivePlate(bus.busplatenumber, bus.id)"
                  data-target="#addDriver"
                  class="add-driver-to-bus add-driver"
                >
                  Add driver
                </button>
              </div>
            </div>
          </div>

          <!-- addind driver to bus modal -->
          <div class="modal fade" id="addDriver">
            <div class="modal-dialog modal-sm modal-dialog-centered">
              <div class="modal-content col-lg-4">
                <div class="modal-body">
                  <div class="modal2-form col-lg-12 mx-auto bg-white">
                    <h6 class="text-center mt-2 mb-3 heading">
                      Add a driver to the bus
                    </h6>
                    <form class="col-lg-12 col-12 py-3">
                      <div class="form-group col-lg-12 col-sm-12 col-12">
                        <input
                          type="text"
                          class="form-control"
                          name="busPlate"
                          v-model="activeBusPlate"
                          placeholder="Bus plate number"
                          required
                          readonly
                        />
                      </div>

                      <div class="form-group my-3 col-lg-12 col-sm-12 col-12">
                        <select
                          class="form-control"
                          name="seats"
                          id="seats"
                          v-model="activeDriver"
                          required
                        >
                          <option v-if="DriversNoBuses!=0" value="" disabled selected>
                            -select bus driver-
                          </option>
                          <option v-else value="" disabled selected>
                            No driver without a bus
                          </option>
                          <option
                            v-for="driver in DriversNoBuses"
                            :value="driver.id"
                            :key="driver.id"
                          >
                            {{ driver.firstname + " " }}{{ driver.lastname }}
                          </option>
                        </select>
                      </div>
                      <div class="actions-btns col-lg-12 col-sm-12 col-12">
                        <button
                          class="btn btn-light my-2 col-sm-12 col-md-4 col-12 col-lg-4 mx-1 px-5"
                          @click="clearTable"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          :disabled="DriversNoBuses==0"
                          name="newBus"
                          @click.prevent="addDriverToBus()"
                          class="btn col-12 my-2 col-sm-12 col-md-5 col-lg-4 mx-1 btn-primary"
                        >
                          Add Driver
                          <span
                            v-if="hasSubmitted"
                            class="spinner-border spinner-border-sm ml-2 my-auto"
                          ></span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="myModal">
          <div class="modal-dialog modal-dialog-centered myModal-md">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form col-lg-12 mx-auto bg-white">
                  <h6 class="text-center mt-2 mb-3 heading">
                    Register new buses of your company
                  </h6>
                  <!-- <h1>{{name}}</h1> -->
                  <form class="col-lg-11 col-12 mx-auto">
                    <div class="inputs d-flex flex-wrap mx-auto">
                      <div
                        class="form-group px-0 col-lg-4 col-sm-6 col-11 mx-3"
                      >
                        <input
                          type="text"
                          class="form-control"
                          name="busPlate"
                          v-model="busPlate"
                          placeholder="Bus plate number"
                          required
                        />
                      </div>

                      <div
                        class="form-group px-0 p col-lg-5 col-sm-6 col-11 mx-2"
                      >
                        <select
                          class="form-control"
                          name="seats"
                          id="seats"
                          v-model="seats"
                          required
                        >
                          <option value="" disabled>-select bus seats-</option>
                          <option value="28">28</option>
                          <option value="32">32</option>
                          <option value="48">48</option>
                        </select>
                      </div>
                      <div class="text-center col-12 col-sm-6 col-lg-2">
                        <button
                          type="submit"
                          name="newBus"
                          @click.prevent="newBus()"
                          class="btn col-12 col-sm-12 btn-primary"
                        >
                          Add Bus
                          <span
                            v-if="addBuSubmitted"
                            class="spinner-border spinner-border-sm ml-2 my-auto"
                          ></span>
                        </button>
                      </div>
                    </div>
                  </form>

                  <div class="added-buses col-lg-11 col-12 mx-auto">
                    <div v-if="!showTable" class="table_placeholder">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="96"
                          height="96"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path
                            d="M17 20H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1zm2-8V5H5v7h14zm0 2H5v4h14v-4zM6 15h4v2H6v-2zm8 0h4v2h-4v-2z"
                            fill="rgba(149,164,166,0.95)"
                          />
                        </svg>
                        <p id="add-buses-text">Added buses will appear here</p>
                      </div>
                    </div>
                    <div
                      v-if="showTable"
                      class="table-container card my-3 col-lg-12 p-0 mx-auto"
                    >
                      <table class="table col-lg-12">
                        <thead class="bg-success">
                          <tr>
                            <th>#</th>

                            <th>Bus plate number</th>
                            <th>Number of seats</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="bus in buses" :key="bus">
                            <td>{{ bus.no }}</td>

                            <td>{{ bus.busPlate }}</td>

                            <td>{{ bus.seats }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="decision-btns ml-auto">
                    <button
                      class="btn px-5"
                      @click="clearTable"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h6>Buses with drivers</h6>
        <div class="card table-view">
          <DataTable
            :value="Buses"
            :paginator="true"
            class="p-datatable-customers"
            :rows="10"
            v-model:selection="selectedProducts3"
            dataKey="id"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]"
            v-model:filters="filters2"
            filterDisplay="row"
            :loading="LoadingData"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            :globalFilterFields="[
              'busplatenumber',
              'driverid',
              'firstname',
              'lastname',
              'capacity',
            ]"
          >
            <template #header>
              <div class="p-d-flex p-jc-end">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters2['global'].value"
                    placeholder="Keyword Search"
                  />
                </span>
              </div>
            </template>
            <template #empty> No buses found. </template>
            <template #loading> Loading buses data. Please wait. </template>
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
            <Column
              field="busplatenumber"
              header="Bus plate number"
              sortable="true"
              style="min-width:12rem"
            >
              <template #body="{ data }">
                {{ data.busplatenumber }}
              </template>
              <template #filter>
                <InputText
                  type="text"
                  v-model="filters2['busplatenumber'].value"
                  :placeholder="`Search by plate number - `"
                />
              </template>
            </Column>

            <Column
              field="firstname"
              header="Bus driver"
              sortable="true"
              style="min-width:12rem"
            >
              <template #body="{ data }">
                {{ data.firstname + " " + data.lastname }}
              </template>
              <template #filter>
                <InputText
                  type="text"
                  v-model="filters2['firstname'].value"
                  class="p-column-filter"
                  :placeholder="`Search by driver name - `"
                />
              </template>
            </Column>

            <Column
              field="capacity"
              header="Bus seats"
              sortable="true"
              style="min-width:12rem"
            >
              <template #body="{ data }">
                {{ data.capacity }}
              </template>
              <template #filter>
                <InputText
                  type="text"
                  v-model="filters2['capacity'].value"
                  class="p-column-filter"
                  :placeholder="`Search by number - `"
                />
              </template>
            </Column>
          </DataTable>
        </div>
        <!-- table card for mobile -->

        <div class="card mobile_cards_instead_of_table">
          <DataView
            :value="Buses"
            :paginator="true"
            :rows="9"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          >
            <template #empty> No Buses found. </template>
            <template #list="slotProps">
              <div class="p-col-12">
                <div class="col-sm-12 col-12 single-card">
                  <div class="sub-content d-flex">
                    <p class="title">Bus plate number:</p>
                    <p class="content pl-2">
                      {{ slotProps.data.busplatenumber }}
                    </p>
                  </div>
                  <div class="sub-content d-flex">
                    <p class="title">Bus Driver:</p>
                    <p class="content pl-2">
                      {{ slotProps.data.firstname
                      }}{{ " " + slotProps.data.lastname }}
                    </p>
                  </div>
                  <div class="sub-content d-flex">
                    <p class="title">Bus Seats:</p>
                    <p class="content pl-2">{{ slotProps.data.capacity }}</p>
                  </div>
                </div>
              </div>
            </template>
          </DataView>
        </div>

        <div class="d-flex loader" v-if="LoadingData">
          <span
            v-if="true"
            class="spinner-border spinner-border-sm ml-2 my-auto"
          ></span>
          <p>Loading data...</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AdminSidebar from "@/components/adminSidebar.vue";
import AdminMobileSidebar from "@/components/AdminMobileSidebar.vue";
//Bootstrap and jQuery libraries
import { FilterMatchMode } from "primevue/api";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import axios from "axios";
import jwt_decode from "jwt-decode";
import router from "../../router/index";
const BusesUrl = `https://bookinga.herokuapp.com/api/v1/company/buses`;
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {
    AdminSidebar,
    AdminMobileSidebar,
  },
  data: function () {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        busplatenumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
        firstname: { value: null, matchMode: FilterMatchMode.CONTAINS },
        capacity: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      LoadingData: true,
      Buses: [],
      Drivers: [],
      busPlate: "",
      seats: "",
      errors: false,
      success: false,
      activeDriver: "",
      updatedBuses: [],
      modalClose: "",
      //adding new bus variables
      showTable: false,
      busPlate: "",
      hasSubmitted:false,
      addBuSubmitted:false,
      activeBusPlate: "",
      activeBusId: "",
      seats: "",
      clicksCounter: 0,
      buses: [],
      BusesNoDrivers: [],
      DriversNoBuses: [],
      //done
    };
  },
  mounted() {
    //API Call
    this.returnBuses();
    this.returnBusesWithNoDrivers();
    this.returnDriversNoBuses();
  },
  methods: {
    returnActivePlate(data, id) {
      this.activeBusPlate = data;
      this.activeBusId = id;
      return this.activeBusPlate;
    },
    //calling API method
    returnBuses() {
      //API Call
      axios
        .get("https://bookinga.herokuapp.com/api/v1/company/buses", config)
        .then((res) => {
          if(res.data.message!="no buses of that company are registered yet"){
            this.Buses = res.data.message;
            this.LoadingData = false;
          }
          else{
            this.LoadingData=false;
          }
        });
    },
    returnDriversNoBuses() {
      axios
        .get(
          "https://bookinga.herokuapp.com/api/v1/company/driver/driver-without-bus",
          config
        )
        .then((res) => {
          if(res.data.message!="Each driver has a bus!"){
            this.DriversNoBuses = res.data.data;
          }
        })
        .catch((res) => {
          alert(res.data);
        });
    },
    returnBusesWithNoDrivers() {
      axios
        .get("https://bookinga.herokuapp.com/api/v1/company/buses/all", config)
        .then((res) => {
          if (
            res.data.message !=
            "there are no buses of this company that have drivers"
          ) {
            this.BusesNoDrivers = res.data.message;
            this.LoadingData = false;
          }
        });
    },

    //registering new company bus
    addDriverToBus() {
      this.hasSubmitted=true;
      axios
        .put(
          `https://bookinga.herokuapp.com/api/v1/company/buses/${this.activeBusId}/${this.activeDriver}`,
          config,
          config
        )
        .then((res) => {
          if (res.data.message == "driver added successfully") {
            
            this.hasSubmitted=false
            this.updatedBuses.push({
              busPlate: this.activeBusPlate,
              driver: this.activeDriver,
            });
            this.activeBusId="",
            this.activeDriver=""
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Driver added to bus successfully",
              group: "br",
              life: 5000,
            });
          } else {
            this.hasSubmitted=false
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: res.data.message,
              group: "br",
              life: 5000,
            });
          }
        });
    },
    newBus() {
      this.seats = Number(this.seats);
      if (this.busPlate != "" && this.seats > 0) {
        this.addBuSubmitted=true
        axios
          .post(
            BusesUrl,
            {
              sits: this.seats,
              busplatenumber: this.busPlate,
            },
            config
          )
          .then((res) => {
            if (res.data.status == 201) {
              this.addBuSubmitted=false
              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Bus saved successfully",
                group: "br",
                life: 5000,
              });
              this.clicksCounter++;
              this.buses.push({
                busPlate: this.busPlate,
                seats: this.seats,
                no: this.clicksCounter,
              });
              this.showTable = true;
              this.busPlate = "";
              this.seats = "";
            } else {
              this.addBuSubmitted=false
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: res.data.message,
                group: "br",
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.addBuSubmitted=false
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: error.message,
              group: "br",
              life: 5000,
            });
          });
      }
      else{
        alert("All the fields are required before you submit")
      }
    },

    //-------------------------------------------------------------------------------------
    clearTable() {
      this.buses.unshift();
      this.showTable = false;
    },
  },

  watch: {
    buses: {
      handler(val, oldVal) {
        this.returnBuses();
        this.returnBusesWithNoDrivers();
      },
      deep: true,
    },
    updatedBuses: {
      handler(val, oldVal) {
        this.returnBuses();
        this.returnBusesWithNoDrivers();
      },
      deep: true,
    },
  },
  created() {
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if( userRole != "admin" && userRole != "developer") {
      return router.push("/dashboard");
    }
    //  else if (userRole == "admin" && decoded.sign_in_account == 1) {
    //   return router.push("/admin/companyReg");
    // }
    
    $(document).ready(function () {
      $(".show-modal").click(function () {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
    $(document).ready(function () {
      $(".add-driver").click(function () {
        $("#addDriver").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
};
</script>
<style lang="scss" scoped>
@import "./sharedStyles.scss";

// -----------------------finished modal stuffs design------------------------
@media only screen and (min-width: 992px) {
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 23%;
  }
}
.page h5 {
  font-size: 1em !important;
}
.modal2-content {
  min-width: fit-content;
  height: auto !important;
}
.modal2-form {
  min-height: 36vh !important;
  padding: 2em;
  border-radius: 5px;
}
.plate > h6 {
  font-size: 1.2em;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.plate {
  width: fit-content;
  margin: 0 auto;
}
.bus-card {
  padding: 1.5em;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f7f7f9;
}
.add-driver-to-bus {
  background: rgb(131, 170, 238);
  color: white;
  border-radius: 4px;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  min-width: fit-content;
}
.page svg {
  margin-left: 5px !important;
  width: 2vw;
  height: 2.6vh;
}
.page {
  margin: 10px 0;
}
@media only screen and (max-width: 600px) {
  .page {
    margin-top: 6em !important;
    margin-bottom: 2em;
  }

  .page svg {
    width: 4vw;
  }

  #entire_app__container {
    height: auto;
    
    .ticket_booking_order {
      .ticket_booking_procedure_container {
        .procedure_form {
          width: 92%;
        }
      }
    }

    .__mobile_navigation {
      display: block;
      width: 100%;
      height: 9vh;
      background: $pureWhite;
      position: fixed;
      top: 0;
      z-index: 5;

      & .logo_container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;

        .menu_toggle {
          width: 22%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .--full_width {
          width: 100% !important;
          height: 50% !important;
        }

        .--sidebar_toggled_hide_logo {
          display: none !important;
        }

        .logo {
          width: 56%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 60%;
            margin-top: 0.2em;
          }
        }

        .settings {
          width: 22%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }

    .entire_app__sidebar_container {
      display: none;
    }

    .entire_app__page_content {
      display: block;
      width: 100%;

      .content_container {
        margin-top: 9vh;
        width: 100%;
      }

      .notifications_container {
        display: none;
      }
    }

    .entire_app_mobile_sidebar_container {
      display: block;
      transition: all 0.5s ease;
      z-index: 4;
      width: 100%;
      height: 92vh;
      background: $pureWhite;
      position: fixed;
      top: 8vh;
      animation: slide_up 0.2s linear;
    }

    @keyframes slide_up {
      0% {
        top: 8vh;
      }
      50% {
        top: 5vh;
      }
      100% {
        top: 8vh;
      }
    }
  }
}
</style>
